"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var clone = require('clone');

var tv4 = require('tv4');

var Dot = /*#__PURE__*/function () {
  function Dot(opt) {
    _classCallCheck(this, Dot);

    this.number = null;
    this.hazardClass = null;
    this.packingGroup = null;
    this.shippingName = null;

    if (opt) {
      this.fillObject(clone(opt));
    }
  }

  _createClass(Dot, [{
    key: "fillObject",
    value: function fillObject(opt) {
      var _this = this;

      Object.keys(this).forEach(function (prop) {
        _this[prop] = opt[prop] || null;
      });
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, Dot.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'dot.schema.json',
        type: 'object',
        properties: {
          number: {
            type: ['string', 'null']
          },
          hazardClass: {
            type: ['string', 'null']
          },
          packingGroup: {
            type: ['string', 'null']
          },
          shippingName: {
            type: ['string', 'null']
          }
        },
        required: Object.keys(this)
      };
    }
  }]);

  return Dot;
}();

module.exports = Dot;